import React from "react";
import { Box, Link, Typography } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

interface CellLinkProps {
    url: string;
    label?: string;
}

export const CellLink: React.FC<CellLinkProps> = ({ url, label }) => {
    const displayLabel = label || url; // Si no hay label, muestra la URL


    if (!url) {
        return (
            <Box
                display="flex"
                alignItems="center"
                justifyContent="left"
                sx={{
                    height: "100%", // Asegura el uso completo de la celda
                    width: "100%", // Asegura que ocupe todo el ancho
                    padding: "0", // Elimina padding adicional
                }}
            >
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 500,
                        fontSize: 14,
                        color: "rgba(0, 0, 0, 0.38)", // Color de texto deshabilitado
                    }}
                >
                    Sin enlace
                </Typography>
            </Box>
        )
    }

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="left"

            sx={{
                height: "100%", // Asegura el uso completo de la celda
                width: "100%", // Asegura que ocupe todo el ancho
                padding: "0", // Elimina padding adicional
            }}
        >
            <Box
                display="flex"
                alignItems="center"
                gap={0.5}
                sx={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                }}
            >
                <Link
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        fontWeight: 500,
                        fontSize: 14,
                        color: "#1976d2", // Color del enlace
                        textDecoration: "none",
                        transition: "color 0.3s ease, text-decoration 0.3s ease", // Animación suave
                        "&:hover": {
                            color: "#0d47a1", // Un tono más oscuro al hacer hover
                            textDecoration: "underline", // Subrayado al hacer hover
                        },
                    }}
                >
                    <Typography
                        variant="body2"
                        sx={{
                            fontWeight: 500,
                            fontSize: 14,
                            color: "inherit", // Usa el color del enlace
                            transition: "color 0.1s ease", // Animación suave
                        }}
                    >
                        {displayLabel}
                    </Typography>
                    <OpenInNewIcon
                        sx={{
                            fontSize: 14,
                            marginLeft: 0.5,
                            color: "inherit", // Sincroniza el color con el enlace
                            transition: "color 0.1s ease", // Animación suave
                        }}
                    />
                </Link>
            </Box>
        </Box>
    );
};
